
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","fill":"none"}},[_c('path',{attrs:{"d":"M4 3a1 1 0 000 2h16a1 1 0 100-2H4zm15 5a1 1 0 10-2 0v10a1 1 0 01-1 1H8a1 1 0 01-1-1V8a1 1 0 10-2 0v10a3 3 0 003 3h8a3 3 0 003-3V8z"}}),_c('path',{attrs:{"d":"M10 9a1 1 0 011 1v6a1 1 0 11-2 0v-6a1 1 0 011-1zm5 1a1 1 0 10-2 0v6a1 1 0 102 0v-6z"}})]);
        };
      

        module.exports = {
          
          render: render,
        };
      